<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import FallbackAvatar from '@/components/ui/FallbackAvatar'

  export default {
    name: 'LikeButton',
    components: {
      FallbackAvatar,
    },
    props: {
      likes: Object,
      panelOpened: Boolean,
      hash: String,
      likeId: String,
    },
    data() {
      return {
        hover: false,
        isHidden: true,
        maxRecordsToShow: 9,
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
      count: {
        set(val) {
          this.$emit('like', val)
        },
        get() {
          return this.likes.data.count
        },
      },
      showMore() {
        return this.maxRecordsToShow < this.likes.data.users.length
      },
      likeButtonText() {
        return this.settings && this.settings.base_options && this.settings.base_options.theme_variant === 'variant' ? this.$t('cta.likes.liked') : ''
      },
    },
    watch: {
      panelOpened(val) {
        this.isHidden = !val
      },
    },
    mounted() {
      this.isHidden = this.hash && this.hash.indexOf('#likes-') === 0 &&
      (this.hash.split('-')[2] === this.likeId.split('-')[2]) ? false : true
    },
    methods: {
      onClickLikeButton() {
        this.count = !this.likes.data.isLiked
      },
      onToggleLikeCount() {
        this.isHidden = !this.isHidden
        this.$emit('onTogglePanel', !this.isHidden ? 'likes' : null)
        this.maxRecordsToShow = 9
      },
      viewMore() {
        this.maxRecordsToShow += 9
      },
    },
  }
</script>
